import { LinkParagraaf } from './getLinksInHoofdstuk';

/**
 * Filters all links that are Eigen.
 *
 * When a link is Eigen, all parents will also be included.
 */
export const filterEigenLinks = (links: LinkParagraaf[]) => {
  return links.filter((link) => {
    link.subparagrafen = link.subparagrafen.filter((subparagraafLink) => {
      subparagraafLink.voorschriften = subparagraafLink.voorschriften.filter(
        (voorschrift) => {
          return voorschrift.VSPB.Type === 'Eigen';
        }
      );

      return (
        subparagraafLink.SPPB.Type === 'Eigen' ||
        subparagraafLink.voorschriften.length > 0
      );
    });

    return link.PHB.Type === 'Eigen' || link.subparagrafen.length > 0;
  });
};
